import { CButton, CCol, CForm, CFormGroup, CImg, CInput, CInputGroup, CInputGroupAppend, CInputGroupText, CLabel, CRow, CSelect } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import { isValidEmail, validarCedula } from './Tools'
import { Icon } from '@iconify/react'
import { CustomSelect } from 'src/security/OTP'
import { RegisterCustomSelect } from './RegisterCustomSelect'
import AxiosManager from 'src/config/axiosManager'
import { provinciasRD } from './RegisterMunicipios'
import validateDate from 'src/reusable/validateDate'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import ilustracion from "../../../../img/pricing-Illustration.svg";
import { RegisterStepLeft } from './RegisterStepLeft'
import coopsyslogo from "../../../../img/CoopSysLogo.png";


export const RegisterStep5 = ({ DataForm, code, setDataForm, onCancel, onSuccess }) => {
    const history = useHistory()
    const [gAuth, setgAuth] = useState("");


    const input1Ref = useRef(null);
    const input2Ref = useRef(null);
    const input3Ref = useRef(null);
    const input4Ref = useRef(null);
    const input5Ref = useRef(null);
    const input6Ref = useRef(null);
    const buttonRef = useRef(null);


    const GAuth = (tok) => {
        if (parseInt(tok.replace(" ", "")) === code) {
            onSuccess()
        } else {
            setgAuth("");
        }
    };
    useEffect(() => {
        if (gAuth.replace("_", "").length === 7) {
            GAuth(gAuth);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gAuth]);

    const Close = () => {
        onCancel()
    }



    return (
        <CRow>
            <RegisterStepLeft DataForm={DataForm} />
            <CCol xs="12" md="8" >
                <form className="otp" style={{ height: 750, width: '100%', padding: 80 }}>
                    <div>
                        <CImg
                            id="logo"
                            className="imagen"
                            src={
                                coopsyslogo
                            }
                        />
                    </div>
                    <div className="title">OTP</div>
                    <div className="title">Codigo de Verificacion</div>
                    <p className="message" style={{ color: 'black' }}>
                        Hemos enviado el codigo de validacion al correo
                        suscriptor  {DataForm.correo}.
                    </p>
                    <div className="inputs" >
                        <NumberFormat
                            className="form-control"
                            value={gAuth}
                            onChange={(e) => setgAuth(e.target.value)}
                            format="### ###"
                            mask="_"
                            style={{ width: 400 }}
                        />
                    </div>

                    <CCol>
                        <div
                            className="row justify-content-center"
                            style={{ flexFlow: "row", paddingTop: 50 }}
                        >
                            <CButton
                                type="submit"
                                style={{ background: 'red', height: 60, padding: 0, margin: 0 }}
                                className="btn-block LoginInput2"
                                onClick={onCancel}
                            >
                                <Icon icon="icon-park-twotone:back" width={25} /> Volver
                            </CButton>
                            <CButton
                                type="submit"
                                color="primary"
                                style={{ height: 60, padding: 0, margin: 0 }}
                                className="btn-block LoginInput2"
                                disabled={parseInt(DataForm.estado) === 0}
                                onClick={() => GAuth(gAuth)}
                            >

                                Validar Codigo OTP
                                <Icon icon="fluent:presence-available-10-regular" width={25} style={{ marginLeft: 10 }} />
                            </CButton>
                        </div>
                    </CCol>

                </form>




            </CCol>
        </CRow>


    )
}
